import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Selects = styled.div`
	display: flex;
	align-items: center;
	margin-top: 1rem;
`;
